import { datajs } from '../shared/utils';

(function() {
	const initCalendarEvents = () => {
		const eventToggles = datajs('event-toggle');

		const handleEventToggleClick = function(e) {
			e.preventDefault();

			const toggle = e.target;
			const eventItem = toggle.closest('.c-eventItem');

			// Set/Remove active class on faq item
			if (eventItem) {
				eventItem.classList.toggle('is-active');
			}
		};

		if (eventToggles && eventToggles.length) {
			Array.from(eventToggles).forEach(toggle => toggle.addEventListener('click', handleEventToggleClick));
		}
	};

	document.addEventListener('DOMContentLoaded', initCalendarEvents);
})();
